import{m as a}from"./chunk-HBP5N4FR.js";a();var r=n=>n.toLowerCase().match(/[0-9a-f]/g),t=n=>n.length%2===0,o=n=>{let e=[];return n&&!r(n)&&e.push(`Invalid Hex characters on argument @${n}`),n&&!t(n)&&e.push(`Odd number of Hex characters on argument @${n}`),e};export{o as a};
//# sourceMappingURL=chunk-4I33RXZI.js.map
